<template>
  <div>
    <div class="container">
      <div class="row my-10 mx-10">
        <div class="col-12 col-lg-6">
          <div class="row">
            <div class="h2 b1">{{ $t("orderForm.requierdInfo") }}</div>
          </div>
          <div class="row">
            <div class="col-6 font14 gray-text">
              {{ $t("mobilePhone") }} <br />
              <span class="b1 h5 text-dark">{{ phoneNumber }}</span>
            </div>
            <div class="col-6 font14 gray-text">
              {{ $t("name") }} <br />
              <span class="b1 h5 text-dark"> {{ name }}</span>
            </div>
          </div>
          <div class="row mt-15 h3 b1">{{ $t("orderForm.offerInfo") }}</div>
          <div class="row">
            <div class="col-6 font14 gray-text">
              {{ $t("job") }} <br /><span class="b1 h5 text-dark">
                {{ job }}</span
              >
            </div>
            <div class="col-6 font14 gray-text">
              {{ $t("univer") }} <br />
              <span class="b1 h5 text-dark">{{ univer }} </span>
            </div>
          </div>
          <div class="row">
            <div class="col-6 font14 gray-text">
              {{ $t("major") }} <br />
              <span class="b1 h5 text-dark"> {{ major }}</span>
            </div>
            <div class="col-6 font14 gray-text">
              {{ $t("email") }} <br />
              <span class="b1 font14 text-dark"> {{ email }} </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 px-8">
          <div class="row b1 h5">
            {{ $t("edit") }} {{ $t("orderForm.requierdInfo") }}
          </div>
          <div class="row">
            <div class="col-6">
              <v-text-field
                                  :label="$t('name')"

                v-model="form.name"
                :rules="nameRules"
                hide-details="auto"
              ></v-text-field>
            </div>
            <div class="col-6">
              <v-text-field
                :label="$t('mobilePhone')"
                v-model="form.phoneNumber"
                :rules="phoneNumberRules"
                hide-details="auto"
                readonly
              ></v-text-field>
            </div>
          </div>
          <div class="row b1 h5 mb-n5 mt-10">
            {{ $t("edit") }} {{ $t("orderForm.offerInfo") }}
          </div>
          <div class="row">
            <div class="col-6">
              <v-text-field
                v-model="form.job"
                :label="$t('job')"
                hide-details="auto"
              ></v-text-field>
            </div>
            <div class="col-6">
              <v-text-field
                v-model="form.univer"
                :label="$t('univer')"
                hide-details="auto"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <v-text-field
                v-model="form.major"
                :label="$t('major')"
                hide-details="auto"
              ></v-text-field>
            </div>
            <div class="col-6">
              <v-text-field
                v-model="form.email"
                :rules="emailRules"
               :label="$t('email')"
                hide-details="auto"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <v-btn @click="editInfo()" class="blue-bcg text-light">{{
              $t("edit")
            }}</v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    phoneNumber: "",
    name: "",
    job: "",
    univer: "",
    major: "",
    email: "",
    form: {
      phoneNumber: "",
      name: "",
      job: "",
      univer: "",
      major: "",
      email: "",
    },
    phoneNumberRules: [
      (v) => !!v || this.$t('phoneNumberRequierd'),
      (v) => v.length == 11 || this.$t('wrongPhone'),
    ],
    nameRules: [(v) => !!v || this.$t('nameRquierd')],
    emailRules: [(v) => /.+@.+/.test(v) || this.$t('wrongEmail')],
  }),
  methods: {
    editInfo() {
      var formInfo = {
        first_name: this.form.name,
        last_name: " ",
        field_of_study: this.form.major,
        university: this.form.univer,
        carry: this.form.job,
        email: this.form.email,
      };
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      this.axios
        .put("account/info/" + this.$session.get("pk") + "/ ", formInfo)
        .then((response) => {
          console.log(response);
          this.axios.defaults.headers.common["Authorization"] =
            "Bearer " + this.$session.get("token");
          this.axios
            .get("account/info/" + this.$session.get("pk") + "/ ")
            .then((response) => {
              console.log(response.data);
              this.form.phoneNumber = response.data.username;
              this.form.name =
                response.data.first_name + " " + response.data.last_name;
              this.phoneNumber = response.data.username;
              this.name =
                response.data.first_name + " " + response.data.last_name;
              this.job = response.data.carry;
              this.email = response.data.email;
              this.univer = response.data.university;
              this.major = response.data.field_of_study;
              this.form.job = response.data.carry;
              this.form.email = response.data.email;
              this.form.univer = response.data.university;
              this.form.major = response.data.field_of_study;
            });
        });
    },
  },
  mounted() {
    this.axios.get("account/pk").then((response) => {
      console.log(response.data[0].pk);
      this.$session.set("pk", response.data[0].pk);
      this.axios
        .get("account/info/" + this.$session.get("pk") + "/ ")
        .then((response) => {
          console.log(response.data);
          this.form.phoneNumber = response.data.phone_number;
          this.form.major = response.data.field_of_study;
          this.form.univer = response.data.university;
          this.form.email = response.data.email;
          this.form.job = response.data.carry;
          this.form.name = response.data.first_name;
          this.phoneNumber = response.data.phone_number;
          this.major = response.data.field_of_study;
          this.univer = response.data.university;
          this.email = response.data.email;
          this.job = response.data.carry;
          this.name = response.data.first_name;
        });
    });
  },
};
</script>
